import { atom } from 'recoil';

const childDetailsState = atom({
    key: 'childDetails',
    default: '',
});

export {
    childDetailsState
};